<div class="gel__text-center mt-5">
  <h1>Sorry, your session has expired.</h1>
  <h3>
    You will be redirected to the <a [attr.href]="loginUrl">Login Page</a> in
    {{ countdown }}
  </h3>
</div>
